/**
 * This is a TypeScript port of the C++ AnimationGroup class from
 * tabanim/public/animation/AnimationGroup.h
 */

import { Animation } from './BaseAnimation';

export abstract class AnimationGroup extends Animation {
  protected children: Animation[] = [];

  constructor() {
    super();
  }

  public getChildren(): readonly Animation[] {
    return this.children;
  }
}
